import React from 'react'

import { PaddingProps } from 'styled-system'

import { SectionWrapper } from 'Components/Blocks'
import { Column, Text } from 'Components/UI'

type Props = PaddingProps

function WorkHeroSection({ ...rest }: Props) {
  return (
    <SectionWrapper {...rest}>
      <Column alignStart fullWidth gap={5}>
        <Text as="h1" medium title title52>
          Crafted for Impact. Built to Scale.
        </Text>

        <Text body body16 maxWidth="640px" semiLight>
          Every project is a reflection of our belief: great tech should be
          fast, intuitive, and ready to grow - no matter the industry.
        </Text>
      </Column>
    </SectionWrapper>
  )
}

export default WorkHeroSection
